import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/auth.service';
import { GlobalService } from 'src/app/global.service';
import { environment } from '../../../environments/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EpinService {

  constructor(
   private authService: AuthService,
   private http: HttpClient,
   public globalService: GlobalService
  ){ }

  async getEpins(req_param:any){
    var isTokenValid = await this.authService.checkAccessTokenValidity();
    
    if (isTokenValid) {
      var APIEndPoint:string = `${environment.cignalApiUrl}/epins/`;

      var body:any = req_param;

      try {
        var response = await lastValueFrom<HttpResponse<any>>(
          this.http.post(APIEndPoint, body, {
              headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("access_token")}`
              },
              observe: 'response',
            }
          )
        );  
        return {
          "total": response.body.total[0].total,
          "items": response.body.items,
          "message": "",
        }; 
      }catch (e:any) {
        console.log(e.error.message);
        return {
          "total": 0,
          "items": [],
          "message": e.error.message,
        }; 
      }

    }else{
      return false;
    }
  }

  async exportEpinRecord(requestParam:any){
    var isTokenValid = await this.authService.checkAccessTokenValidity();
    if (isTokenValid) {
      var APIEndPoint:string = `${environment.cignalApiUrl}/download/epins/`;
      requestParam.username = this.globalService.getUserInformation().username;
      var body = requestParam;
      try {
        var response = await lastValueFrom<HttpResponse<any>>(
          this.http.post(APIEndPoint, body, {
              headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("access_token")}`
              },
              observe: 'response',
            }
          )
        );
        return {
          "success": true,
          "message": response.body.message
        };
      } catch (e:any) {
        return {
          "success": false,
          "message": e.error.message
        }; 
      }
    }else{
      return false;
    }
  }

}
